import "./StoreBadges.css";
import appStoreBadge from "../../assets/badge-app-store.svg";
import googlePlayBadge from "../../assets/badge-google-play.svg";

// pt/ct are Apple's provider and campaign tokens — they attribute the install
// to the web onboarding. Play has no equivalent on this link yet.
const APP_STORE_URL =
  "https://apps.apple.com/app/apple-store/id1551848949?pt=122647219&ct=web_onboarding&mt=8";
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=app.migiri.purple";

// rel is "noopener" and deliberately not "noreferrer": stripping the referrer
// could cost us store-side attribution.
function StoreBadges() {
  return (
    <div className="store-badges">
      <a href={APP_STORE_URL} target="_blank" rel="noopener">
        <img src={appStoreBadge} alt="Download on the App Store" />
      </a>
      <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener">
        <img src={googlePlayBadge} alt="Get it on Google Play" />
      </a>
    </div>
  );
}

export default StoreBadges;
